"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.UserInfo = styled_components_1.default.div `
  display: inline-flex;
  align-items: flex-end;
  background: rgb(238, 240, 236);

  padding: 2px 5px 5px 5px;

  border-radius: 0 0 0 10px;

  align-items: center;

  font-size: 11px;

  div:first-of-type {
    border-left: 2px solid rgb(128, 128, 128);
    border-right: 2px solid rgb(128, 128, 128);

    padding: 0 5px;
    margin: 0 5px;
  }
`;
//# sourceMappingURL=user-info.js.map